import { render, staticRenderFns } from "./jdlhfwt.vue?vue&type=template&id=6361fb13&scoped=true"
import script from "./jdlhfwt.vue?vue&type=script&lang=js"
export * from "./jdlhfwt.vue?vue&type=script&lang=js"
import style0 from "./jdlhfwt.vue?vue&type=style&index=0&id=6361fb13&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361fb13",
  null
  
)

export default component.exports